import React from 'react';
import {Button, ButtonGroup, Col, Modal, ModalBody, ModalFooter, Row, Table} from 'reactstrap';
import BaseComponent from '../BaseComponent';
import Checkbox from '../../components/Checkbox';
import PropTypes from 'prop-types';
import ModalPagination from '../ModalPagination';
import label from 'enqc-utilities/src/label/Label'
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {parseDate} from "../../utils/Utilities";
import {DD_MMMM_YYYY_HH_MM_SS} from "../../utils/Global";
import ModalCardHeader from "../Widget/ModalCardHeader";
import DropdownInput from "../form/DropdownInput";
import SearchInput from "../SearchInput";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import NumberInput from "../Widget/NumberInput";

export default class MasterComponentSelectionModal extends BaseComponent{


    constructor(props){
        super(props);
        let state = this.state
        state.search = ''
        state.backdrop = false
        state.show = this.props.show
        state.masterComponents = new Array()
        state.selectedMasterComponents = new Array()
        state.page = 1
        state.sortir = "mc.created"
        state.ascending = false

        this.setState(state)
    }

    componentWillReceiveProps(props, nextContext) {
        let show = this.state.show
        if(this.props!=props){
            this.setState({
                show:props.show,
            }, () => {
                if(props.show) {
                    this.fetchMasterComponents()
                }
            })
        }
    }

    refresh = (ascending, sortir) => (
        this.setState({
            ascending:ascending,
            sortir:sortir
        }, () => {
            this.fetchMasterComponents()
        })
    )

    fetchMasterComponents = () =>{
        let {selectedMasterComponents, page, ascending, sortir, search} = this.state
        if(!selectedMasterComponents){
            selectedMasterComponents = new Array()
        }

        this.get(Endpoint.API.MASTER_COMPONENTS, {
            params:{
                page: page-1,
                ascending: ascending,
                sortir: sortir,
                search: search,
            }
        }, null, response=>{
            if(response.code===200){
                let masterComponents = response.data
                if(!masterComponents){
                    masterComponents = []
                }
                masterComponents.forEach((masterComponent, j)=>{
                    masterComponent.checked = false
                    masterComponent.quantity = 1
                    selectedMasterComponents.forEach((selectedMasterComponent, i)=>{
                        if(selectedMasterComponent.id===masterComponent.id){
                            masterComponent.checked = true
                            masterComponent.quantity = selectedMasterComponent.quantity
                        }
                    })
                })
                this.setState({
                    masterComponents:masterComponents,
                    totalPage: response.totalPage,
                    totalElement: response.totalElement,
                    pageElement: response.pageElement,
                })
            }
        }, true, true)
    }

    close = () =>{
        this.setState({
            selectedMasterComponents:new Array(),
            masterComponents:new Array(),
            show: false,
        }, () => {
            this.props.cancelCallback()
        })
    }

    render(){
        let {show, masterComponents, selectedMasterComponents, search,  page, totalPage, totalElement, pageElement, ascending, sortir} = this.state ;
        if(!selectedMasterComponents){
            selectedMasterComponents = new Array()
        }
        let orderOptions = delegateObjectsForSelection(
            {name:label.Name, field:'mc.label'},
            {name:label.Created, field:'mc.created'},
            {name:label.Updated, field:'mc.updated'}
        )
        let ascendingOptions = delegateObjectsForSelection(  {name:label.Descending, field:false}, {name:label.Ascending, field:true})


        return (
            <Modal
                size="xl"
                style={{minWidth:'65%'}}
                className="border-primary"
                centered={true}
                isOpen={show}
                backdrop={true}
                zIndex="1">
                {super.render()}
                <ModalCardHeader content={label.ComponentList}/>
                <ModalBody>
                    <Row>
                        <Col md={6}>
                            <ButtonGroup className="d-flex w-100">
                                <DropdownInput
                                    title={label.SortBy}
                                    options={orderOptions}
                                    onSelect={(item) => {
                                        this.refresh(ascending, item.field, true)
                                    }}
                                    onReset={() => {
                                        this.refresh(ascending, "created", true)
                                    }}/>
                                &nbsp;&nbsp;&nbsp;
                                <DropdownInput
                                    options={ascendingOptions}
                                    onSelect={(item) => {
                                        this.refresh(item.field, sortir, true)
                                    }}
                                    onReset={() => {
                                        this.refresh(true, sortir, true)
                                    }}/>
                            </ButtonGroup>
                        </Col>
                        <Col md={6}>
                            <SearchInput
                                placeholder={label.Search}
                                value={search}
                                onChange={(e) => {
                                    let value = e.target.value
                                    this.setState({search:value, page:1}, () => {
                                        if(value==''){
                                            this.fetchMasterComponents()
                                        }
                                    })
                                }}
                                onEnter={(e) => {
                                    let value = e.target.value
                                    this.setState({search:value, page:1}, () => {
                                        this.fetchMasterComponents()
                                    })
                                }}/>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col>
                            <Table responsive hover>
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{label.Label}</th>
                                    <th>{label.Description}</th>
                                    <th>{label.CharacterLength}</th>
                                    <th>{label.Quantity}</th>
                                    <th>{label.Updated}</th>
                                    <th>{label.Check}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    masterComponents.map((item, index)=>(
                                        <tr className="align-items-center align-content-center" valign="center" key={index}>
                                            <th scope="row">
                                                {((page-1)* pageElement)+(index+1)}
                                            </th>
                                            <td>{item.label}</td>
                                            <td>{item.description}</td>
                                            <td>{item.length}</td>
                                            <td>
                                                <NumberInput
                                                    maxLength={3}
                                                    className="text-center"
                                                    style={{fontSize:'17px', minHeight:'21px', maxWidth:'52px'}}
                                                    value={item.quantity}
                                                    onChangeEvent={(e, maskedvalue, floatvalue) => {
                                                        item.quantity = floatvalue
                                                        this.setState({masterComponents})
                                                    }}/>
                                            </td>
                                            <td>{parseDate(item.updated, DD_MMMM_YYYY_HH_MM_SS)}</td>
                                            <td>
                                                <Checkbox
                                                    checked={item.checked}
                                                    onChange={(checked) => {
                                                        masterComponents[index].checked = checked
                                                        if(checked){
                                                            selectedMasterComponents.push(item)
                                                        }else{
                                                            selectedMasterComponents.forEach((selectedMasterComponent, j)=>{
                                                                if(selectedMasterComponent.id===item.id){
                                                                    selectedMasterComponents.splice(j, 1)
                                                                }
                                                            })
                                                        }
                                                        this.setState({masterComponents, selectedMasterComponents})
                                                    }
                                                    }/></td>
                                        </tr>
                                    ))
                                }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalPagination {...this.props} currentPage={page} pageCount={totalPage} onSelect={(page)=>{
                    this.setState({
                        page:page
                    }, () => {
                        this.fetchMasterComponents()
                    })
                }}/>
                <ModalFooter>
                    <Button color="secondary" onClick={e=>{
                        e.preventDefault()
                        if(this.props.cancelCallback){
                            this.props.cancelCallback()
                        }
                        this.close()
                    }}>
                        {label.Cancel}
                    </Button>
                    <Button color="primary" onClick={e=>{
                        e.preventDefault()
                        if(this.props.okCallback){
                            this.props.okCallback(selectedMasterComponents)
                        }
                        this.close()
                    }}>
                        {label.Update}
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

MasterComponentSelectionModal.propTypes = {
    exclusionMasterComponents : PropTypes.array,
    show : PropTypes.bool.isRequired,
    okCallback : PropTypes.func,
    cancelCallback : PropTypes.func
}
